"use strict";

var _slicedToArray = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactifySearchProvider = void 0;

var react_1 = __importDefault(require("react")); // @ts-expect-error missing types


var GaGtag = __importStar(require("ga-gtag"));

var package_json_1 = __importDefault(require("../../../package.json"));

var hooks_1 = require("../../hooks");

var components_1 = require("../../components");

var utility_1 = require("../../utility");

var ReactifySearchProvider = function ReactifySearchProvider(props) {
  react_1.default.useEffect(function () {
    utility_1.debug.log("ReactifySearchProvider", "props", props);
    GaGtag.install("G-DV00Z0X5VP", {
      cookie_prefix: "_rs",
      user_properties: {
        shop: props.shopifyPermanentDomain,
        version: package_json_1.default.version
      }
    });
  }, [props]);
  return react_1.default.createElement(ReactifySearchInner, Object.assign({}, props));
};

exports.ReactifySearchProvider = ReactifySearchProvider;

var ReactifySearchInner = function ReactifySearchInner(props) {
  var _a, _b;

  var _ref = (0, hooks_1.useConfig)(props.shopifyPermanentDomain, (_a = props.preload) === null || _a === void 0 ? void 0 : _a.config),
      config = _ref.config;

  var theme = (_b = props.theme) !== null && _b !== void 0 ? _b : {
    typography: {
      fontFamily: "inherit",
      fontSize: "inherit"
    }
  };
  var searchTermFromURL = react_1.default.useMemo(function () {
    var _a;

    if (typeof window === "undefined") {
      return;
    }

    var urlParams = new URLSearchParams(window.location.search);
    return (_a = urlParams.get("q")) !== null && _a !== void 0 ? _a : undefined;
  }, [typeof window !== "undefined" && window.location.search]);
  var searchSortFromURL = react_1.default.useMemo(function () {
    var _a;

    if (typeof window === "undefined") {
      return;
    }

    var urlParams = new URLSearchParams(window.location.search);
    return (_a = urlParams.get("sort")) !== null && _a !== void 0 ? _a : undefined;
  }, [typeof window !== "undefined" && window.location.search]);
  var indexFromURL = react_1.default.useMemo(function () {
    var _a;

    if (typeof window === "undefined") {
      return;
    }

    var urlParams = new URLSearchParams(window.location.search);
    return (_a = urlParams.get("index")) !== null && _a !== void 0 ? _a : undefined;
  }, [typeof window !== "undefined" && window.location.search]);

  var _react_1$default$useS = react_1.default.useState(searchTermFromURL !== null && searchTermFromURL !== void 0 ? searchTermFromURL : ""),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      searchTerm = _react_1$default$useS2[0],
      setSearchTerm = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(false),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      showInstantSearchResults = _react_1$default$useS4[0],
      setShowInstantSearchResults = _react_1$default$useS4[1];

  var _react_1$default$useS5 = react_1.default.useState(searchSortFromURL !== null && searchSortFromURL !== void 0 ? searchSortFromURL : ""),
      _react_1$default$useS6 = _slicedToArray(_react_1$default$useS5, 2),
      sortOption = _react_1$default$useS6[0],
      setSortOption = _react_1$default$useS6[1];

  var _react_1$default$useS7 = react_1.default.useState([]),
      _react_1$default$useS8 = _slicedToArray(_react_1$default$useS7, 2),
      results = _react_1$default$useS8[0],
      setResults = _react_1$default$useS8[1];

  var _react_1$default$useS9 = react_1.default.useState(),
      _react_1$default$useS10 = _slicedToArray(_react_1$default$useS9, 2),
      resultStats = _react_1$default$useS10[0],
      setResultStats = _react_1$default$useS10[1];

  react_1.default.useEffect(function () {
    if (searchTermFromURL && searchTerm !== searchTermFromURL) {
      setSearchTerm(searchTermFromURL);
    }
  }, [searchTermFromURL]);
  react_1.default.useEffect(function () {
    if (searchSortFromURL && sortOption !== searchSortFromURL) {
      setSortOption(searchSortFromURL);
    }
  }, [searchSortFromURL]);
  var contextValue = react_1.default.useMemo(function () {
    var _a, _b, _c;

    if (!config) {
      return;
    }

    return {
      config: config,
      options: Object.assign(Object.assign({}, props), {
        clientId: (_a = props.clientId) !== null && _a !== void 0 ? _a : "theme",
        index: (_c = (_b = props.index) !== null && _b !== void 0 ? _b : indexFromURL) !== null && _c !== void 0 ? _c : config.index,
        filtersHandle: props.filtersHandle,
        credentials: props.credentials,
        theme: theme
      }),
      search: {
        searchTerm: searchTerm,
        setSearchTerm: setSearchTerm,
        showInstantSearchResults: showInstantSearchResults,
        setShowInstantSearchResults: setShowInstantSearchResults
      },
      sortby: {
        sortOption: sortOption,
        setSortOption: setSortOption
      },
      results: {
        results: results,
        setResults: setResults,
        resultStats: resultStats,
        setResultStats: setResultStats
      }
    };
  }, [config, props, searchTerm, showInstantSearchResults, sortOption, results, resultStats]);
  utility_1.debug.hook("ReactifySearchProvider", "context", contextValue);

  if (!contextValue) {
    if (props.renderBooting) {
      return props.renderBooting();
    }

    return null;
  }

  return react_1.default.createElement(hooks_1.ReactifySearchContext.Provider, {
    value: contextValue
  }, react_1.default.createElement(components_1.UtilityAuthenticatedReactiveBase, null, props.children));
};